(function() {
    'use strict';
    
a3_cabin_reports.controller('FaqsModalCtrl' ,FaqsModalCtrl)
  
    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name FaqsModalCtrl
    * @description 
    *   Shows an FAQ 
    * @ngInject
    */
function FaqsModalCtrl($scope, $uibModalInstance, pair) {
    $scope.pair = pair;
    $scope.cancel = cancel;

    /**
     * Close the modal
     * @memberof FaqsModalCtrl
     */
    function cancel() {
        $uibModalInstance.close('close');
    }
}

})();